const INITIAL_STATE = {
  newsFilter: '',
  selectedNews: 0
};

export const newsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_ADMIN_NEWS_PAGE_FILTER_STRING':
      return {
        ...state,
        newsFilter: action.payload
      };
    case 'UPDATE_ADMIN_NEWS_PAGE_SELECTED_NEWS':
      return {
        ...state,
        selectedNews: action.payload
      };
    default:
      return state;
  }
};
